import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetricCard = ({ title, value, change, changeType, icon, trend }) => {
  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success bg-success/10';
      case 'negative':
        return 'text-error bg-error/10';
      case 'neutral':
        return 'text-muted bg-muted';
      default:
        return 'text-muted bg-muted';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div className="flex-1">
          <p className="text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground">{value}</h3>
        </div>
        <div className="p-2 md:p-3 rounded-lg bg-primary/10 text-primary flex-shrink-0">
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${getChangeColor(changeType)}`}>
          <Icon name={getChangeIcon(changeType)} size={12} />
          <span className="text-xs font-medium">{change}</span>
        </div>
        {trend && (
          <span className="text-xs text-muted-foreground">{trend}</span>
        )}
      </div>
    </div>
  );
};

export default PerformanceMetricCard;